export default __webpack_public_path__ + "static/media/pexels-chokniti-khongchum-2280551.a5f62119.jpg";